Ext.define('SA.EditPanelController', {
    constructor({view, headerSelectionButtons, subheader = null, enabledSection, disabledSections}) {
        this.view = view;
        this.headerSelectionButtons = headerSelectionButtons;
        this.subheader = subheader;
        this.enabledSection = enabledSection;
        this.disabledSections = disabledSections;
    },

    eachEnabledItem(callback) {
        this.enabledSection.eachItem(callback);
        return this;
    },

    eachItem(callback) {
        this.enabledSection.eachItem(callback);
        this.disabledSections.eachItem(callback);
        return this;
    },

    getDisabledSectionById(sectionId) {
        return this.disabledSections.getSectionById(sectionId);
    },

    getEnabledItemEl(id) {
        return this.enabledSection.findItem(id)?.el.dom;
    },

    getView() {
        return this.view;
    },

    onClearClick(callback, scope) {
        this.headerSelectionButtons.onClearClick(callback, scope);
    },

    onItemChange(callback, scope) {
        this.enabledSection.onItemChange(callback, scope);
    },

    onSelectAllClick(callback, scope) {
        this.headerSelectionButtons.onSelectAllClick(() => Ext.callback(callback, scope, [this.enabledSection.getIds()]));
    },

    setDisabledIds(ids) {
        this.disabledSections.setIds(ids);
        return this;
    },

    setEnabledIds(ids) {
        this.headerSelectionButtons.setEnabled(ids.length > 0);
        this.subheader?.setVisible(ids.length > 0);
        this.enabledSection.setIds(ids);
        return this;
    }
});